export enum QueryKeys {}

export enum MutationKeys {
  SIGNIN = "SignIn",
}
